/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Kariéra',
    titleMeta: 'Kariéra — Volná místa | CamDiab',
    descriptionMeta: 'Prozkoumejte kariérní příležitosti v CamDiab. Připojte se k našemu týmu pro lepší péči o diabetes.',
    keywords: 'CamDiab kariéra, práce, volná místa, diabetes',
    localeMeta: 'cs_cz',

    bannerTitle: 'Volná pracovní místa',
    bannerSubtitle: 'Máte zájem o práci v našem týmu?',
    heroNote: 'Všechny nabídky jsou zveřejněny v angličtině.',

    introBody:
        'Hledáte novou výzvu a chcete spoluvytvářet smysluplné změny? Rádi od vás uslyšíme. Investujeme do našich lidí — tep CamDiab. Zaměstnanecké výhody mají přinést to nejlepší z každého, mimo jiné:',

    benefitsTitle: '',
    benefits: [
        'Štědrý příspěvek zaměstnavatele na penzi',
        'Soukromé zdravotní pojištění',
        'Životní pojištění',
        'Roční diskreční bonus',
        '29 dnů dovolené plus 8 státních svátků',
        'Možnost pracovat na průlomové technologii s potenciálem změnit péči o diabetes a zlepšit výsledky pro pacienty',
        'Kolaborativní a dynamické pracovní prostředí',
        'Konkurenceschopný plat a benefity včetně profesního rozvoje a kariérního postupu',
    ],

    outroHtml:
        'Pokud vás naplňuje skutečný dopad v praxi, rádi od vás uslyšíme:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Žádná volná místa',
    emptyVacancyBody:
        'Momentálně možná nehledáme nové kolegy, ale CamDiab roste a vždy nás zajímají lidé vášnivě usilující o lepší život s diabetem. Vraťte se sem později.',

    applyLabel: 'Přihlásit se',
};
